/**
 * The name of the Supabase MFA factor that carries RepTree passkeys (server lib/passkeys/bridge.ts). Hosted Supabase has
 * no WebAuthn second step, so the server checks the passkey itself and then passes this hidden authenticator-app (TOTP)
 * factor on the person's behalf; only the server holds its code. The server knows the bridge by the factor id it stores
 * (a name can be copied), and its answers already leave the bridge out of the authenticator apps.
 */
export const PASSKEY_BRIDGE_NAME = 'RepTree passkeys';
/** Whether a factor looks like the passkey bridge, by name: only for a screen that cannot ask the server (offline). */
export const isPasskeyBridge = (f) => f.factor_type === 'totp' && f.friendly_name === PASSKEY_BRIDGE_NAME;
/** `base`, or `base 2`, `base 3`… : the first that is not taken (a passkey's or an app's name, unique on the account). */
export function uniqueName(base, taken) {
    const used = new Set(taken);
    if (!used.has(base))
        return base;
    for (let n = 2;; n++)
        if (!used.has(`${base} ${n}`))
            return `${base} ${n}`;
}
//# sourceMappingURL=second-step.js.map